import { useState, useCallback } from 'react';

export default function useModal<TContext extends unknown>(isOpen = false) {
    const [context, setContext] = useState<TContext | undefined>(undefined);
    const [open, setOpenState] = useState(isOpen);

    const onOpen = useCallback((context?: TContext) => {
        setOpenState(true);
        setContext(context);
    }, []);

    const onClose = useCallback(() => {
        setOpenState(false);
        setContext(undefined);
    }, []);

    return {
        context,
        open,
        onOpen,
        onClose
    };
};
